import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { School, Users, Home as HomeIcon } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";

const AUDIENCES = [
  { icon: School, title: "Online schools & districts", text: "Standards-aligned mindful curriculum across all 7 subject areas, K-12." },
  { icon: Users, title: "Teachers", text: "AI-generated lessons, quizzes and reflection insights for every learner." },
  { icon: HomeIcon, title: "Parents & homeschool", text: "Calm, guided daily learning with visible emotional growth." },
];

export const SchoolsCTA = ({ label = "Bring it to your school" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="schools-cta-btn" className="px-6 py-3 rounded-full bg-[#C87D53] text-white font-medium hover:bg-[#B36C44] transition-colors">
          {label}
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#FDFBF7] rounded-3xl max-w-lg max-h-[92vh] overflow-y-auto" data-testid="schools-cta-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#2C4A3E]">Consciousness-based learning for everyone</DialogTitle>
          <DialogDescription>Tell us about your learners and we'll set up a guided demo.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 mt-1">
          {AUDIENCES.map(({ icon: Icon, title, text }) => (
            <div key={title} className="flex gap-3 p-3 rounded-2xl bg-[#F7F3EB]">
              <Icon className="w-5 h-5 text-[#C87D53] mt-0.5 shrink-0" />
              <div><b className="text-stone-800 text-sm">{title}</b><p className="text-xs text-stone-600">{text}</p></div>
            </div>
          ))}
        </div>
        <LeadForm onDone={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};
